// The phone tab bar (x-ui.tabbar), in plain JS so every page with the new-design top bar gets it without
// registering an Alpine component. A tab with pages opens its sheet (scrim, close button or Escape closes it,
// focus goes back to the tab); scrolling down past 40px shrinks the bar to icons, scrolling up, reaching the top
// or tapping the small bar brings it back (it carries a grab handle and the label "Show labels" meanwhile).

function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const bar = root.querySelector('[data-tb-bar]');
    const scrim = root.querySelector('[data-tb-scrim]');
    const sheets = [...root.querySelectorAll('[data-tb-sheet]')];
    const tabs = [...root.querySelectorAll('[data-tb]')];
    let open = null;
    let small = false;

    const setSmall = (on) => {
        if (on === small) return;
        small = on;
        root.classList.toggle('ui-small', on);
        if (on) bar.setAttribute('aria-label', 'Show labels');
        else bar.setAttribute('aria-label', 'Sections');
    };

    const close = (refocus = false) => {
        if (!open) return;
        const was = open;
        open = null;
        sheets.forEach((s) => { s.hidden = true; });
        tabs.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        scrim.hidden = true;
        if (refocus) root.querySelector(`[data-tb="${was}"]`)?.focus();
    };

    const show = (key) => {
        close();
        const sheet = sheets.find((s) => s.dataset.tbSheet === key);
        if (!sheet) return;
        open = key;
        sheet.hidden = false;
        scrim.hidden = false;
        root.querySelector(`[data-tb="${key}"]`)?.setAttribute('aria-expanded', 'true');
        (sheet.querySelector('.ui-tbs-it.ui-on') || sheet.querySelector('.ui-tbs-it'))?.focus({ preventScroll: true });
    };

    // The small bar: the first tap anywhere on it only brings it back.
    bar.addEventListener('click', (e) => {
        if (small) {
            e.preventDefault();
            e.stopPropagation();
            setSmall(false);
            return;
        }
        const tab = e.target.closest('[data-tb]');
        if (!tab) return;
        if (open === tab.dataset.tb) close();
        else show(tab.dataset.tb);
    }, true);

    scrim.addEventListener('click', () => close());
    root.querySelectorAll('[data-tb-close]').forEach((b) => b.addEventListener('click', () => close(true)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && open) close(true); });

    // Shrink on scroll: passive listener, one rAF per frame, reads scrollY only.
    let lastY = window.scrollY;
    let ticking = false;
    const onScroll = () => {
        ticking = false;
        const y = window.scrollY;
        const dy = y - lastY;
        if (Math.abs(dy) <= 6 && y >= 40) return;
        lastY = y;
        if (y < 40 || dy < 0) setSmall(false);
        else if (dy > 6) setSmall(true);
        if (Math.abs(dy) > 6) close();
    };
    window.addEventListener('scroll', () => {
        if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });

    // Labels never clip: if they don't fit at full size, tighten them, then fall back to icons only.
    const fit = () => {
        if (small) return;
        root.classList.remove('ui-tight', 'ui-icons');
        if (getComputedStyle(root).display === 'none') return;
        if (bar.scrollWidth > bar.clientWidth) root.classList.add('ui-tight');
        if (bar.scrollWidth > bar.clientWidth) root.classList.add('ui-icons');
    };
    fit();
    document.fonts?.ready.then(fit);
    let resized;
    window.addEventListener('resize', () => { cancelAnimationFrame(resized); resized = requestAnimationFrame(fit); }, { passive: true });
}

function boot() {
    document.querySelectorAll('[data-ui-tabbar]').forEach(setup);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
document.addEventListener('livewire:navigated', boot);
